import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import { en } from "./locales/en";
import { es } from "./locales/es";

export const resources = {
  en,
  es,
} as const;

/**
 * Every namespace the resource bundles carry, DERIVED from those bundles rather
 * than listed beside them.
 *
 * Hand-maintaining the list let it drift: shipped namespaces (accounts,
 * backflow_devices, categoricalStandards, documents, exceedances,
 * labs, orgDefaults, sampling) were absent from it while live components
 * consumed them. Their keys
 * still resolved — with `resources` supplied up front and no backend
 * configured, every bundle is in the store from `init` and `ns` only declares
 * what to preload — so nothing went red, but `Namespace` was derived from the
 * short list and therefore named a set the package does not actually have.
 * Deriving both from `en` makes the two agree by construction.
 */
const namespaces = Object.keys(resources.en);

export type Namespace = keyof (typeof resources)["en"];

export function initI18n(options?: { lng?: string }) {
  return i18next.use(initReactI18next).init({
    resources,
    ns: namespaces,
    defaultNS: "common",
    fallbackNS: "common",
    fallbackLng: "en",
    lng: options?.lng,
    interpolation: { escapeValue: false },
  });
}

export const i18n = i18next;
